var React = require('react');

function NumberStoryTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M85.6887 66.6363L84.5936 138.046L0.554031 64.6589L85.6887 66.6363Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M147.274 35.9771L84.4878 138.101L85.6148 66.7808L147.274 35.9771Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M147.27 35.9766L85.6537 66.7586L0.547958 64.6605L147.27 35.9766Z","fill":"#5915C7","key":2})]);
}

NumberStoryTriangle.defaultProps = {"width":"176","height":"157","viewBox":"0 0 176 157","fill":"none"};

module.exports = NumberStoryTriangle;

NumberStoryTriangle.default = NumberStoryTriangle;
